import { MyDatePickerModel } from '../../helpers/date.converter';
import { DateConverter } from '../../helpers/date.converter';
import { Moment } from 'moment';
import * as moment from 'moment';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';

export class DateRangeDto {
    startDate?: string;
    endDate?: string;
}

export class DateRangeModel {
    dpStartDate: MyDatePickerModel;
    dpEndDate: MyDatePickerModel;

    startDate: Moment;
    endDate: Moment;

    setMomentDatesFromStorage(storage: DateRangeDto) {
        if (storage.startDate) {
            this.startDate = moment(storage.startDate);
        }

        if (storage.endDate) {
            this.endDate = moment(storage.endDate);
        }
    }

    startDateChanged(event: MatDatepickerInputEvent<Moment>) {
        this.startDate = event.value;
    }

    endDateChanged(event: MatDatepickerInputEvent<Moment>) {
        this.endDate = event.value;
    }

    convertDatesToDto() {
        var dto = new DateRangeDto();
        dto.startDate = DateConverter.fromDateToServerString(this.startDate);
        dto.endDate = DateConverter.fromDateToServerString(this.endDate);

        return dto;
    }

    exportDatesForStorage() {
        return {
            startDate: this.startDate ? this.startDate.toString() : null,
            endDate: this.endDate ? this.endDate.toString() : null
        };
    }

    reset() {
        this.startDate = null;
        this.endDate = null;
        this.dpStartDate = null;
        this.dpEndDate = null;
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/models/common/date.range.ts